import React from 'react';

import { cn } from '@lyearn/style';
import { Image } from '@lyearn/ui';
import { getMediaIcon } from '@/features/media/utils';

import { useMediaContext } from '../context';

interface IconProps {
  className?: string;
  classes?: { image?: string; icon?: string };
}

function MediaIcon(props: IconProps) {
  const { classes, className } = props;
  const { media } = useMediaContext();

  const { image, Icon } = getMediaIcon(media);

  return image ? (
    <Image alt={media.name} className={cn(className, classes?.image)} src={image} />
  ) : (
    <Icon className={cn(className, classes?.icon)} />
  );
}

export default React.memo(MediaIcon);
